import readStringEnv from './readStringEnv';

const readRequiredStringEnv = (envValue: string | undefined, envKey: string): string => {
  const value: string | null = readStringEnv(envValue);
  if (value === null) {
    throw new Error('The environment variable must be configured [EnvKey: ' + envKey + ']');
  }
  return value;
};

export default readRequiredStringEnv;
